/* src/app/TuningSelector.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	select_option,
	select_value,
	text
} from "../_snowpack/pkg/svelte/internal.js";

import { tuning } from "./store.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[4] = list[i][0];
	child_ctx[5] = list[i][1];
	return child_ctx;
}

// (26:2) {#each tunings as [name, notes]}
function create_each_block(ctx) {
	let option;
	let t_value = /*name*/ ctx[4] + "";
	let t;
	let option_value_value;

	return {
		c() {
			option = element("option");
			t = text(t_value);
			option.__value = option_value_value = /*notes*/ ctx[5];
			option.value = option.__value;
		},
		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

function create_fragment(ctx) {
	let select;
	let mounted;
	let dispose;
	let each_value = /*tunings*/ ctx[1];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			select = element("select");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(select, "name", "tuning");
			attr(select, "class", "w-full rounded-lg border-gray-200");
			if (/*theTuning*/ ctx[0] === void 0) add_render_callback(() => /*select_change_handler*/ ctx[3].call(select));
		},
		m(target, anchor) {
			insert(target, select, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(select, null);
			}

			select_option(select, /*theTuning*/ ctx[0]);

			if (!mounted) {
				dispose = listen(select, "change", /*select_change_handler*/ ctx[3]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*tunings*/ 2) {
				each_value = /*tunings*/ ctx[1];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(select, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*theTuning, tunings*/ 3) {
				select_option(select, /*theTuning*/ ctx[0]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(select);
			destroy_each(each_blocks, detaching);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { defaultTuning } = $$props;

	const tunings = [
		["E Standard", "E2 A2 D3 G3 B3 E4"],
		["Drop D", "D2 A2 D3 G3 B3 E4"],
		["Drop C", "C2 G2 C3 F3 A3 D4"],
		["B Standard - Seven string", "B2 E2 A2 D3 G3 B3 E4"],
		["Drop A - Seven string", "A1 E2 A2 D3 G3 B3 E4"]
	];

	let theTuning = defaultTuning.join(" ");

	function select_change_handler() {
		theTuning = select_value(this);
		$$invalidate(0, theTuning);
		$$invalidate(1, tunings);
	}

	$$self.$$set = $$props => {
		if ('defaultTuning' in $$props) $$invalidate(2, defaultTuning = $$props.defaultTuning);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*theTuning*/ 1) {
			$: {
				tuning.set(Array.isArray(theTuning)
				? theTuning
				: theTuning.split(" "));
			}
		}
	};

	return [theTuning, tunings, defaultTuning, select_change_handler];
}

class TuningSelector extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { defaultTuning: 2 });
	}
}

export default TuningSelector;